export enum BwjTextFieldType {
    Text = 'text',
    Email = 'email',
    Password = 'password',
    RevealablePassword = 'password',
    Search = 'search',
    Url = 'url',
  }